/**
 * ServeFirst public-site details shown in the survey app (SF-4600).
 *
 * Pages served from our servefirst.ai survey hosts show the servefirst.ai
 * website, email and privacy policy. Every other host (our .co.uk hosts,
 * customer domains, localhost) keeps the servefirst.co.uk details as before.
 */
import { isAiPlatformHost } from "./apiBase";

export const BRAND_SITES = {
  couk: {
    website: "www.servefirst.co.uk",
    email: "info@servefirst.co.uk",
    privacyPolicyUrl: "https://www.servefirst.co.uk/privacy-policy/",
  },
  ai: {
    website: "www.servefirst.ai",
    email: "info@servefirst.ai",
    privacyPolicyUrl: "https://www.servefirst.ai/legal/privacy-policy",
  },
};

/**
 * @param {string} [host]  defaults to window.location.host
 */
export function getBrandSite(host) {
  const h =
    host !== undefined
      ? host
      : typeof window !== "undefined"
        ? window.location.host
        : "";
  return isAiPlatformHost(h) ? BRAND_SITES.ai : BRAND_SITES.couk;
}

export default getBrandSite;
